import React from 'react'
import CreateContainer from '../../../../component/organization/create-organization/AddContainer'

function AddOrganization() {
  return (
     <div className='page-body'>
        <CreateContainer/>
     </div>
  )
}

export default AddOrganization
